import dynamicImportPolyfill from 'dynamic-import-polyfill';
import { renderUI } from './index';

// This needs to be done before any dynamic imports are used.
if (typeof dynamicImportPolyfill !== 'undefined') {
  dynamicImportPolyfill.initialize({
    modulePath: '/dir', // Defaults to '.'
  });
}

renderUI();
